import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { INBOX_STATES } from '@/lib/publication-inbox'
import type { InboxState } from '@/services/publication-inbox-service'

interface InboxStateTabsProps {
  value: InboxState
  counts?: Partial<Record<InboxState, number>>
  onChange: (value: InboxState) => void
}

/** Abas por estado legível (Nova, Em triagem, Prazo lançado, Sem providência, Conferidas). */
export function InboxStateTabs({ value, counts, onChange }: InboxStateTabsProps) {
  return (
    <Tabs value={value} onValueChange={(next) => onChange(next as InboxState)}>
      <TabsList className="flex-wrap">
        {INBOX_STATES.map((state) => (
          <TabsTrigger key={state.value} value={state.value}>
            {state.label}
            {counts?.[state.value] !== undefined && (
              <span className="ml-1 tabular-nums text-muted-foreground">({counts[state.value]})</span>
            )}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
